"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      "body-style": {
        padding: 0,
        minWidth: "80vw",
        display: "flex",
        justifyContent: "center"
      },
      visible: _vm.previewVisible,
      footer: null,
      centered: "",
      closable: false
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, [_c("img", {
    staticClass: "w-[90vh] h-[90vw] bg-white fixed left-[50%] top-[50%] -translate-x-[50%] -translate-y-[50%] object-contain",
    attrs: {
      src: _vm.src,
      alt: ""
    }
  })]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;